var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrevious1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.709595 35.4803V4.96729H43.2859V44.7051H10.6441L0.709595 35.4803Z",
    fill: "#7CAF92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.709595 31.2227V0.709717H43.2859V40.4476H10.6441L0.709595 31.2227Z",
    fill: "#FFF4E3",
    stroke: "white",
    strokeWidth: 1.41921
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6254 19.7347V22.1129H17.3566V24.491H14.9785V22.1129H12.6003V19.7347H14.9785V17.3566H17.3566V19.7347H31.6254ZM19.7347 14.9785H17.3566V17.3566H19.7347V14.9785ZM19.7347 14.9785H22.1129V12.6003H19.7347V14.9785ZM19.7347 26.8691H17.3566V24.491H19.7347V26.8691ZM19.7347 26.8691H22.1129V29.2473H19.7347V26.8691Z",
    fill: "#4F6F5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious1);
export default __webpack_public_path__ + "static/media/previous-1.0de7e7140c286e6f1753fce005f9934c.svg";
export { ForwardRef as ReactComponent };